// useGetConcurrentEnrollmentDiscounts.ts
import { useGet } from './useApi';
// import { ConcurrentEnrollmentDiscount } from '../shared-typings/models/concurrent-enrollment-discount.model';

// Define a proper type for concurrent enrollment discount
export interface ConcurrentEnrollmentDiscount {
  id: number;
  scheduleId: number;
  concurrentId: number;
  oneDay: number | string;
  twoDay: number | string;
  threeDay: number | string;
  fourDay: number | string;
  fiveDay: number | string;
  programId?: number;
  siteId?: number;
  day?: string;
  updated?: string;
  updatedBy?: number;
}

/**
 * Se o back-end retorna um objeto: { [scheduleId: string]: ConcurrentEnrollmentDiscount[] },
 * tipar como Record<string, ConcurrentEnrollmentDiscount[]>.
 */
export const useGetConcurrentEnrollmentDiscounts = (scheduleId?: number) => {
  return useGet<ConcurrentEnrollmentDiscount[]>(
    '/v1/public/reg/concurrent-enrollment-discounts',
    {
      params: {
        scheduleId,
      },
    }
  );
};

export default useGetConcurrentEnrollmentDiscounts;
